import React from "react"
import Checkbox from "../../ui/checkbox/checkbox"
import Input from "../../ui/inputs/input"

/**
 * Reusable "Send to lead booker / alternate email" control.
 *
 * Used by every payment-action UI that fires an email (send link, take card,
 * charge saved card, refund) so the staff member can override the recipient
 * when the person on the phone isn't the lead booker.
 *
 * Props:
 *   leadBookerEmail   - email on file for the lead booker (string | null)
 *   leadBookerLabel   - "Lewis Newson <lewis@…>" or similar (string, display only)
 *   useLeadBooker     - controlled bool
 *   onToggle          - (nextBool) => void
 *   alternateEmail    - controlled string
 *   onAlternateChange - (string) => void
 *   error             - optional inline error string
 */
export default function RecipientPicker({
	leadBookerEmail,
	leadBookerLabel,
	useLeadBooker,
	onToggle,
	alternateEmail,
	onAlternateChange,
	error,
	checkboxLabel = "Send receipt to lead booker",
}) {
	const leadAvailable = Boolean(leadBookerEmail)
	const showAlternate = !useLeadBooker || !leadAvailable

	return (
		<div>
			{leadAvailable && (
				<div style={{ marginBottom: showAlternate ? 8 : 0 }}>
					<Checkbox
						label={`${checkboxLabel}${leadBookerLabel ? ` (${leadBookerLabel})` : ""}`}
						checked={useLeadBooker}
						onClick={() => onToggle(!useLeadBooker)}
					/>
				</div>
			)}

			{!leadAvailable && (
				<p style={{ fontSize: 12, color: "#b54708", marginBottom: 8 }}>
					Lead booker has no email on file — supply an alternate below.
				</p>
			)}

			{showAlternate && (
				<Input
					type="email"
					placeholder="Recipient email:"
					value={alternateEmail}
					onChange={onAlternateChange}
				/>
			)}

			{error && <p style={{ fontSize: 12, color: "#b42318", marginTop: 6 }}>{error}</p>}
		</div>
	)
}
